import { render, staticRenderFns } from "./ContractorReviewNew.vue?vue&type=template&id=a5820716&scoped=true"
import script from "./ContractorReviewNew.vue?vue&type=script&lang=ts"
export * from "./ContractorReviewNew.vue?vue&type=script&lang=ts"
import style0 from "./ContractorReviewNew.vue?vue&type=style&index=0&id=a5820716&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5820716",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5820716')) {
      api.createRecord('a5820716', component.options)
    } else {
      api.reload('a5820716', component.options)
    }
    module.hot.accept("./ContractorReviewNew.vue?vue&type=template&id=a5820716&scoped=true", function () {
      api.rerender('a5820716', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/companyContractors/ContractorReviewNew.vue"
export default component.exports